import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import Home from './pages/Home'
import MaternityCalculator from './pages/MaternityCalculator'
import AllowanceCalculator from './pages/AllowanceCalculator'
import BatchProcessor from './pages/BatchProcessor'
import HistoryRecords from './pages/HistoryRecords'
import './styles/global.css'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hr" element={<Home />} />
        <Route path="/maternity" element={<MaternityCalculator />} />
        <Route path="/allowance" element={<AllowanceCalculator />} />
        <Route path="/batch" element={<BatchProcessor />} />
        <Route path="/history" element={<HistoryRecords />} />
      </Routes>
    </Router>
  )
}

export default App
